import { pipe } from 'fp-ts/function';
import { ReactNode } from 'react';
import { PaymentMethod } from '@mews-commander/data-access';
import { withAsyncContainer } from '@mews-commander/ui';
import { WithAccountId } from '@mews-commander/types';
import { usePaymentMethodDetails } from './queries';
import { PaymentMethodDetailsSidebarContent } from './PaymentMethodDetailsSidebarContent';

interface Props extends WithAccountId {
    paymentCardId: string;
    paymentMethodType: PaymentMethod;
}

const PaymentMethodDetailsContentWrapper = pipe(
    ({ children }: { children: ReactNode }) => <>{children}</>,
    withAsyncContainer
);

export const PaymentMethodDetailsSidebar = ({ paymentCardId, accountId, paymentMethodType }: Props) => {
    const {
        data: paymentMethod,
        isFetching: isPaymentMethodDataFetching,
        isError: hasPaymentMethodDataFailed,
    } = usePaymentMethodDetails({
        id: paymentCardId,
        accountId,
        paymentMethod: paymentMethodType,
    });

    return (
        <PaymentMethodDetailsContentWrapper
            isFetching={isPaymentMethodDataFetching}
            hasFailed={hasPaymentMethodDataFailed}
        >
            {paymentMethod && (
                <PaymentMethodDetailsSidebarContent
                    paymentMethod={paymentMethod}
                    paymentMethodType={paymentMethodType}
                    accountId={accountId}
                />
            )}
        </PaymentMethodDetailsContentWrapper>
    );
};
